// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__3XE73","head":"Table_head__2P7c6","col":"Table_col__1R7C7"};